import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment-timezone';

@Pipe({ name: 'momentFromNow' })
export class MomentFromNowPipe implements PipeTransform {
  transform(value: number, withoutSuffix = true, timezone: string): string | null {
    return moment.unix(value / 1000).tz(timezone)
      .fromNow(withoutSuffix)?.replace('minutes', 'mins');
  }
}
